import { render, staticRenderFns } from "./5.vue?vue&type=template&id=fc7f635a&scoped=true&"
var script = {}
import style0 from "./5.vue?vue&type=style&index=0&id=fc7f635a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7f635a",
  null
  
)

export default component.exports